var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half is-offset-one-quarter box"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }